import React, { useState, useMemo, useEffect } from "react";
// import { API } from "aws-amplify";
import MediaQuery from "react-responsive";
import { List, ListItem, ListItemIcon, ListItemText, IconButton, SwipeableDrawer, withStyles, Typography, Button, Collapse } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DrawerNavLink, DRAWER_MODAL_PROPS, useDeferredHistoryPush } from "../../utils/drawer-nav";

import Dashboard from "@material-ui/icons/Dashboard";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PersonOutline from "@material-ui/icons/PersonOutline";
import HomeIcon from "@material-ui/icons/HomeRounded";
import GavelIcon from "@material-ui/icons/GavelRounded";
import TicketIcon from "@material-ui/icons/ConfirmationNumberRounded";
import TicketTrackIcon from "@material-ui/icons/ConfirmationNumber";
import DescriptionIcon from "@material-ui/icons/DescriptionRounded";
import ListIcon from "@material-ui/icons/ListRounded";
import MenuIcon from "@material-ui/icons/Menu";
import Receipt from "@material-ui/icons/Receipt";
import ExitToApp from "@material-ui/icons/ExitToApp";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Logo from "../../images/fansfirst-logo-mobile.svg";
import LogoFr from "../../images/fansfirst-logo-small-fr.svg";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import TEAMS, { getTeamsGroupedByLeague } from "../../constants/Teams";

import {
  getSavedLang,
  saveLang,
  guessLangFromBrowser,
  getLangFromUrl,
  setLangInUrl,
  withLang,
} from "../../utils/lang";
import { PHONE_QC, PHONE_DEFAULT } from "../../utils/phones";
import analytics, { trackOncePerPage } from "../../analytics";

const styles = (theme) => ({
  navContainer: {
    boxShadow: "0 4px 6px 0 rgba(0,0,0,0.03)",
    position: "fixed",
    width: "100%",
    backgroundColor: "#fafafa",
    zIndex: "1300",
    paddingBottom: "4px",
  },
  nav: { 
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "auto",
    flexWrap: "wrap",
    position: "relative",
  },
  callUsContainer: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    textDecoration: "none",
    boxSizing: "border-box",
    flexWrap: "wrap",
    gap: "2px",
  },
  questionsText: {
    color: "#00A0FF",
    fontWeight: "bold",
    display: "inline",
    fontSize: "16px",
    whiteSpace: "nowrap",
  },
  sellButton: {
    minWidth: theme.spacing.unit * 0.5,
    height: theme.spacing.unit * 0.5,
    backgroundColor: "#00de94",
    color: "#ffffff",
    verticalAlign: "middle",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#00c281",
    },
    textTransform: "none",
    marginRight: "5px",
  },
  phoneNumberText: {
    color: "#5F666F",
    fontWeight: "bold",
    display: "inline",
    marginLeft: "0.25rem",
    fontSize: "16px",
    whiteSpace: "nowrap",
  },
  menuContainer: {
    flex: 0,
    display: "flex",
    alignItems: "center",
    gap: "4px",
    minWidth: "fit-content",
  },
  logoContainer: {
    paddingTop: `${theme.spacing.unit}px`,
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
    minWidth: "80px",
    maxWidth: "150px",
  },
  logo: {
    verticalAlign: "middle",
    height: "36px",
    maxWidth: "100%",
  },
  icon: { color: "#fff" },
  divider: { backgroundColor: "white" },
  listItemText: { padding: "0 16px 0 0" },
  langToggle: {
    display: "inline-flex",
    border: "1px solid #BDBDBD",
    borderRadius: 999,
    overflow: "hidden",
    height: 28,
    alignSelf: "center",
    background: "#fff",
    minWidth: "auto",
    maxWidth: "68px",
    flexShrink: 0,
    fontSize: "10px",
  },
  langBtn: {
    padding: "0 4px",
    fontWeight: 700,
    lineHeight: "26px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "10px",
    flex: "0 1 auto",
    textAlign: "center",
    whiteSpace: "nowrap",
    minWidth: "auto",
    color: "#000",
  },
  langBtnActive: { 
    background: "#2196F3", 
    color: "#fff", 
    fontWeight: 800 
  },
  langToggleDrawer: {
    margin: `8px ${theme.spacing.unit * 2}px`,
  },
});

const mobileNav = ({ classes, isAuthenticated, currUser, handleLogout, t, i18n, history }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAccountDrawerOpen, setIsAccountDrawerOpen] = useState(false);
  const { requestPush, slideProps } = useDeferredHistoryPush(history);
  const pathname = history && history.location && history.location.pathname;

  const [lang, setLang] = useState(
    getLangFromUrl() || getSavedLang() || guessLangFromBrowser()
  );
  const phoneNumber = useMemo(() => {
    if (lang === "fr") return PHONE_QC;
    if (lang === "en") return PHONE_DEFAULT;
    const guess = guessLangFromBrowser();
    if (guess === "fr") return PHONE_QC;
    return PHONE_DEFAULT;
  }, [lang]);

  useEffect(() => {
    const curr = (i18n && i18n.language) || "";
    const norm = curr.startsWith("fr") ? "fr" : curr.startsWith("en") ? "en" : curr;
    if (norm && norm !== lang) setLang(norm);
  }, [i18n && i18n.language]);
  useEffect(() => {
    setIsDrawerOpen(false);
    setIsAccountDrawerOpen(false);
  }, [pathname]);
  const logoSrc = lang === "fr" ? LogoFr : Logo;

  // const persistPreferredLang = (l) => {
  //   try {
  //     if (!isAuthenticated || !currUser || !currUser.email) return;
  //     const email = String(currUser.email || "").toLowerCase();
  //     API.post("v2", "marketplace/users/update-preferred-lang", {
  //       body: {
  //         email,
  //         preferredLang: l,
  //       },
  //     }).catch(() => {});
  //   } catch (_) {}
  // };
  const persistPreferredLang = () => {};

  const chooseLang = (l) => {
    const curr = (i18n && i18n.language) || "";
    if (curr === l || curr.startsWith(l)) return;
    setLang(l);
    saveLang(l);
    if (getLangFromUrl() !== l) setLangInUrl(l);
    i18n.changeLanguage(l);
    persistPreferredLang(l);
    analytics.track("language_selected", { language: l });
  };

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);
  const toggleAccountDrawer = () => setIsAccountDrawerOpen(!isAccountDrawerOpen);
  const closeMainDrawer = () => setIsDrawerOpen(false);
  const closeAccountDrawer = () => setIsAccountDrawerOpen(false);
  const MainDrawerLink = (props) => (
    <DrawerNavLink onClose={closeMainDrawer} onLeaveLayout={requestPush} {...props} />
  );
  const AccountDrawerLink = (props) => (
    <DrawerNavLink onClose={closeAccountDrawer} onLeaveLayout={requestPush} {...props} />
  );

  function phoneHref(num) {
    const digits = String(num || "").replace(/\D/g, "");
    return `sms:+1-${digits}`;
  }

  const renderCallUs = () => (
    <MediaQuery maxWidth={959}>
      <a
        className={classes.callUsContainer}
        href={phoneHref(phoneNumber)}
        style={{ alignItems: "center" }}
        onClick={() => analytics.track("support_link_clicked", { channel: "sms", surface: "header", device_type: "mobile" })}
      >
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", width: "100%", gap: "2px" }}>
          <Typography className={classes.questionsText}>
            {t("common.questions_text")}
          </Typography>
          <Typography className={classes.phoneNumberText}>{phoneNumber}</Typography>
        </div>
      </a>
    </MediaQuery>
  );

  const [expandedLeagues, setExpandedLeagues] = useState({});

  const toggleLeague = (league, e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    if (!expandedLeagues[league]) {
      trackOncePerPage(`league:${league}`, "league_selected", { league });
    }
    setExpandedLeagues((prev) => ({
      ...prev,
      [league]: !prev[league],
    }));
  };

  const renderTeams = () => {
    const teamsByLeague = getTeamsGroupedByLeague(TEAMS);
    const leagues = Object.keys(teamsByLeague);

    return leagues.map((league) => {
      const isExpanded = Boolean(expandedLeagues[league]);
      const leagueTeams = teamsByLeague[league];

      return (
        <React.Fragment key={league}>
          <ListItem
            button
            onClick={(e) => toggleLeague(league, e)}
          >
            <ListItemText
              disableTypography
              primary={
                <Typography
                  variant="body2"
                  style={{
                    color: "#FFFFFF",
                    font: "Avenir",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  {league}
                </Typography>
              }
            />
            {isExpanded ? (
              <ExpandLess className={classes.icon} />
            ) : (
              <ExpandMore className={classes.icon} />
            )}
          </ListItem>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit={false}>
            <List component="div" disablePadding>
              {leagueTeams.map((game, index) => (
                <MainDrawerLink
                  to={withLang(`/${game.homeTeamSlug}/games`, lang)}
                  style={{ textDecoration: "none" }}
                  key={game.homeTeamSlug || index}
                >
                  <ListItem
                    button
                    style={{ paddingLeft: "32px" }}
                    onClick={() => {
                      trackOncePerPage(`team:${game.homeTeamSlug}`, "team_selected", {
                        team: game.homeTeamSlug,
                      });
                      analytics.track("games_list_opened", {
                        team: game.homeTeamSlug,
                        source: "mobile_nav",
                      });
                    }}
                  >
                    <ListItemIcon>
                      <TicketIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {(() => {
                            const isFr = ((i18n && i18n.language) || "").toLowerCase().startsWith("fr");
                            let teamLabel = game.name;
                            if (isFr) {
                              const slug = game.homeTeamSlug;
                              const type = game.type || "";
                              if (slug === "grey-cup") {
                                teamLabel = "la Coupe Grey";
                              } else if (type === "UFC" || /ufc/i.test(slug) || /ufc/i.test(game.name)) {
                                teamLabel = "l’UFC Fight Night";
                              } else if (type === "Concert" && /taylor\s+swift/i.test(game.name)) {
                                teamLabel = game.name; // no article for artist
                              } else if (["NHL", "AHL", "CFL", "NBA", "MLB", "MLS", "WHL", "NLL"].includes(type)) {
                                teamLabel = `les ${game.name}`;
                              }
                            }
                            return t("common.buy_team_tickets", { team: teamLabel });
                          })()}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
              ))}
            </List>
          </Collapse>
        </React.Fragment>
      );
    });
  };

  const renderDrawer = () => (
    <SwipeableDrawer
      open={isDrawerOpen}
      onClose={closeMainDrawer}
      onOpen={() => setIsDrawerOpen(true)}
      disableBackdropTransition
      ModalProps={DRAWER_MODAL_PROPS}
      transitionDuration={{ enter: 225, exit: 0 }}
      SlideProps={slideProps}
    >
      <div
        tabIndex={0}
        role="button"
        onClick={closeMainDrawer}
        onKeyDown={closeMainDrawer}
        style={{ backgroundColor: "#2faaf3", width: "300px", height: "100%" }}
      >
        <div className={classes.list}>
          <List style={{ backgroundColor: "#2faaf3" }}>
            <ListItem button>
              <ListItemIcon>
                <CloseRoundedIcon className={classes.icon} />
              </ListItemIcon>
            </ListItem>
            {/* toggle bahasa */}
            <div
              className={`${classes.langToggle} ${classes.langToggleDrawer}`}
              aria-label="Language switcher"
              onClick={(event) => event.stopPropagation()}
            >
              <button
                className={`${classes.langBtn} ${lang === "fr" ? classes.langBtnActive : ""}`}
                onClick={() => chooseLang("fr")}
                type="button"
              >
                {t("common.lang_fr")}
              </button>
              <button
                className={`${classes.langBtn} ${lang === "en" ? classes.langBtnActive : ""}`}
                onClick={() => chooseLang("en")}
                type="button"
              >
                {t("common.lang_en")}
              </button>
            </div>
            <MainDrawerLink to={withLang("/", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <HomeIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      type="body2"
                      style={{
                        color: "#FFFFFF",
                        font: "Avenir",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      {t("common.home")}
                    </Typography>
                  }
                />
              </ListItem>
            </MainDrawerLink>

            {isAuthenticated ? (
              <>
                <MainDrawerLink to={withLang("/dashboard", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button>
                    <ListItemIcon>
                      <Dashboard className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.dashboard")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
                <MainDrawerLink to={withLang("/account", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button>
                    <ListItemIcon>
                      <PersonOutline className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.profile")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
                <MainDrawerLink to={withLang("/track-order", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button>
                    <ListItemIcon>
                      <TicketTrackIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.track_tickets")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
                <MainDrawerLink to={withLang("/orders", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button>
                    <ListItemIcon>
                      <Receipt className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.orders")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
                <MainDrawerLink to={withLang("/listings", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button>
                    <ListItemIcon>
                      <ListIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.listings_sell")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
              </>
            ) : (
              <>
                <MainDrawerLink to={withLang("/sell", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button onClick={() => analytics.track("sell_clicked", {})}>
                    <ListItemIcon>
                      <TicketIcon className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.sell_tickets")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
                <MainDrawerLink to={withLang("/signup", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button onClick={() => analytics.track("signup_clicked", {})}>
                    <ListItemIcon>
                      <ExitToApp className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.sign_up")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
                <MainDrawerLink to={withLang("/login", lang)} style={{ textDecoration: "none" }}>
                  <ListItem button onClick={() => analytics.track("login_opened", {})}>
                    <ListItemIcon>
                      <PersonOutline className={classes.icon} />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          type="body2"
                          style={{
                            color: "#FFFFFF",
                            font: "Avenir",
                            fontSize: "15px",
                            fontWeight: "bold",
                          }}
                        >
                          {t("common.log_in")}
                        </Typography>
                      }
                    />
                  </ListItem>
                </MainDrawerLink>
              </>
            )}

            <Divider className={classes.divider} />
            {renderTeams()}
            <Divider className={classes.divider} />

            <MainDrawerLink to={withLang("/legal", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <GavelIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      type="body2"
                      style={{
                        color: "#FFFFFF",
                        font: "Avenir",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      {t("common.legal")}
                    </Typography>
                  }
                />
              </ListItem>
            </MainDrawerLink>
            <MainDrawerLink to={withLang("/why-us", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <DescriptionIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      type="body2"
                      style={{
                        color: "#FFFFFF",
                        font: "Avenir",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      {t("common.about")}
                    </Typography>
                  }
                />
              </ListItem>
            </MainDrawerLink>
            <MainDrawerLink to={withLang("/faqs", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <ListIcon className={classes.icon} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      type="body2"
                      style={{
                        color: "#FFFFFF",
                        font: "Avenir",
                        fontSize: "15px",
                        fontWeight: "bold",
                      }}
                    >
                      {t("common.faqs")}
                    </Typography>
                  }
                />
              </ListItem>
            </MainDrawerLink>
          </List>
        </div>
      </div>
    </SwipeableDrawer>
  );

  const renderAccountDrawer = () => (
    <SwipeableDrawer
      anchor="right"
      open={isAccountDrawerOpen}
      onClose={closeAccountDrawer}
      onOpen={() => setIsAccountDrawerOpen(true)}
      disableBackdropTransition
      ModalProps={DRAWER_MODAL_PROPS}
      transitionDuration={{ enter: 225, exit: 0 }}
      SlideProps={slideProps}
    >
      <div tabIndex={0} role="button" onClick={closeAccountDrawer} onKeyDown={closeAccountDrawer}>
        <div className={classes.list}>
          <List>
            <AccountDrawerLink to={withLang("/dashboard", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <Dashboard />
                </ListItemIcon>
                <ListItemText primary={t("common.dashboard")} className={classes.listItemText} />
              </ListItem>
            </AccountDrawerLink>
            <AccountDrawerLink to={withLang("/account", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <PersonOutline />
                </ListItemIcon>
                <ListItemText primary={t("common.profile")} className={classes.listItemText} />
              </ListItem>
            </AccountDrawerLink>
            <AccountDrawerLink to={withLang("/track-order", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <TicketIcon />
                </ListItemIcon>
                <ListItemText primary={t("common.track_tickets")} className={classes.listItemText} />
              </ListItem>
            </AccountDrawerLink>
            <AccountDrawerLink to={withLang("/orders", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <Receipt />
                </ListItemIcon>
                <ListItemText primary={t("common.orders")} className={classes.listItemText} />
              </ListItem>
            </AccountDrawerLink>
            <AccountDrawerLink to={withLang("/listings", lang)} style={{ textDecoration: "none" }}>
              <ListItem button>
                <ListItemIcon>
                  <ListIcon />
                </ListItemIcon>
                <ListItemText primary={t("common.listings_sell")} className={classes.listItemText} />
              </ListItem>
            </AccountDrawerLink>
            <Divider />
            <ListItem button onClick={handleLogout}>
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText primary={t("common.logout")} className={classes.listItemText} />
            </ListItem>
          </List>
        </div>
      </div>
    </SwipeableDrawer>
  );

  return (
    <div className={classes.navContainer}>
      <nav className={classes.nav}>
        <div className={classes.menuContainer} style={{ position: "relative", top: "4px" }}>
          <IconButton color="primary" aria-label="Menu" onClick={() => toggleDrawer()}>
            <MenuIcon />
          </IconButton>
        </div>
        <div className={classes.logoContainer}>
          <a href={withLang("/", lang)}>
            <img src={logoSrc} alt="FansFirst Logo" className={classes.logo} />
          </a>
        </div>
        <div className={classes.menuContainer}>
          <div className={classes.langToggle} aria-label="Language switcher">
            <button
              className={`${classes.langBtn} ${lang === "fr" ? classes.langBtnActive : ""}`}
              onClick={() => chooseLang("fr")}
              type="button"
            >
              {t("common.lang_fr")}
            </button>
            <button
              className={`${classes.langBtn} ${lang === "en" ? classes.langBtnActive : ""}`}
              onClick={() => chooseLang("en")}
              type="button"
            >
              {t("common.lang_en")}
            </button>
          </div>
          {isAuthenticated ? (
            <IconButton color="primary" aria-label="Menu" onClick={() => toggleAccountDrawer()}>
              <AccountCircle />
            </IconButton>
          ) : (
            <Button
              className={classes.sellButton}
              href={withLang("/sell", lang)}
              variant="extendedFab"
              onClick={() => analytics.track("sell_clicked", {})}
            >
              <Typography style={{ margin: "-8px", color: "white", fontSize: "12px" }}>
                {t("mobile.sell")}
              </Typography>
            </Button>
          )}
        </div>
      </nav>
      {renderDrawer()}
      {isAuthenticated && renderAccountDrawer()}
      {renderCallUs()}
    </div>
  );
};

export default withRouter(withStyles(styles)(withTranslation()(mobileNav)));
